import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

const MIGRATIONS = [
  { key: 'lpo_sailors',      col: 'sailors' },
  { key: 'lpo_priorities',   col: 'priorities' },
  { key: 'lpo_reminders',    col: 'reminders' },
  { key: 'lpo_passdown',     col: 'passdown' },
  { key: 'lpo_programs',     col: 'programs' },
  { key: 'lpo_notes',        col: 'notes' },
  { key: 'lpo_evals',        col: 'evals' },
  { key: 'lpo_awards',       col: 'awards' },
  { key: 'lpo_selres',       col: 'selres' },
  { key: 'lpo_crossassigned',col: 'crossassigned' },
];

/**
 * Reads all LPO localStorage keys and batch-writes them to Firestore.
 * Strips local `id` fields — Firestore generates new document IDs.
 * @param {string} uid
 * @returns {Promise<{ migrated: number }>}
 */
export async function migrateLocalStorage(uid) {
  let migrated = 0;
  for (const { key, col } of MIGRATIONS) {
    let items;
    try { items = JSON.parse(localStorage.getItem(key)) || []; } catch { items = []; }
    if (!items.length) continue;
    const ref = collection(db, `users/${uid}/${col}`);
    for (const item of items) {
      const { id: _omit, ...rest } = item;
      await addDoc(ref, rest);
      migrated++;
    }
  }
  return { migrated };
}

const MIGRATION_DONE_KEY = 'lpo_migration_done';
export const hasMigrated  = () => localStorage.getItem(MIGRATION_DONE_KEY) === 'true';
export const markMigrated = () => localStorage.setItem(MIGRATION_DONE_KEY, 'true');
